<template>
  <div class="wrap">
    <h3 class="title">我的评测</h3>
    <el-table :data="tableData" border style="width: 100%" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
      <el-table-column prop="name" label="课程名称" width="180"> </el-table-column>
      <el-table-column prop="comment" label="评测内容" > </el-table-column>
      <el-table-column prop="modify_time" label="评测时间" width="180"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
    };
  },
  created(){
    this.getCourseList()
  },
  methods:{
    async getCourseList() {
      const data = {
   
      }
      try {
        const res = await this.$axios.post('/stu/course/myClassComment', data)
        if (res.data.code === 200 && res.data.data) {
            this.tableData = res.data.data.list
        }
      } catch (error) {
         console.log(error)
      }
    },
  }
};
</script>

<style lang="scss" scoped>
li,
ul,
p,
h4 {
  margin: 0;
  padding: 0;
  list-style: none;
}
.wrap {
  background: #ffffff;
  margin: 25px 0px 25px 25px;
  width: 100%;
  padding: 20px 30px;
  height: 880px;
  overflow-y: auto;
  scrollbar-width: none; 
  -ms-overflow-style: none; 
  .title {
    font-size: 20px;
    color: #202020;
    padding-bottom: 17px;
    border-bottom: 1px solid #e8eaec;
  }
}
.wrap ::-webkit-scrollbar {
    display: none;
  }
</style>